import {
  Component,
  OnInit,
  OnDestroy,
  ViewContainerRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { DndDropEvent } from 'ngx-drag-drop';
import { UUID } from 'angular2-uuid';
import * as _ from 'lodash';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationModalComponent } from '@app/form-builder/shared/confirmation-modal/confirmation-modal.component';
import { PreviewHtmlComponent } from '@app/form-builder/shared/preview-html/preview-html.component';
import socialIcons from '@app/form-builder/shared/drag-drop-content/elements/social-property/social-icons';
import { GeneratedCodeModalComponent } from '../generated-code-modal/generated-code-modal.component';
import { FormBuilderService } from '../form-builder-service.service';
import { I18nService } from '@app/form-builder/shared/i18n.service';
import { ComponentSettingInterface } from '@app/form-builder/shared/drag-drop-content/interfaces/component-setting.interface';
import { FormDragAndDropInterface, FormInterface } from '@app/form-builder/shared/drag-drop-content/interfaces/form.interface';
import { ElementInterface } from '@app/form-builder/shared/drag-drop-content/interfaces/element.interface';
import { BreadCrumb } from '@app/interfaces';
import { FormService, LocalStorageService } from '@app/services';
import { BUTTON, CHECKBOX, DROPDOWN, INITIAL_FORM, INPUT, PICTURE, RADIO_BUTTON, SEPERATOR, SOCIAL, SPACER, TABLE, TEXT, TEXTAREA, TOGGLE, UPLOADER } from "../form-builder.config";
import { ActivatedRoute, Router } from '@angular/router';
import Notify from 'devextreme/ui/notify';
import { AppNotification } from '@app/helpers';
import { APP_ROUTES } from '@app/constants';
import { SectionInterface } from '@app/form-builder/shared/drag-drop-content/interfaces/section.interface';
@Component({
  selector: 'app-form-parser',
  templateUrl: './form-parser.component.html',
  styleUrls: ['./form-parser.component.scss']
})
export class FormParserComponent implements OnInit {
  @ViewChild('popover') popover!: NgbPopover;
  formEditable: boolean = true;
  formViewClass: string = 'tablet-mode';
  @Output() onChangeHandler = new EventEmitter()
  @Input() formState: any;
  @Input() formId: string;
  @Input() disabled: boolean = false;

  @Input() formConfig: FormDragAndDropInterface;

  crumbpath: BreadCrumb[] = [{
    name: 'Home',
    path: '/home',
  }, {
    name: 'Survey',
    path: '/survey',
  }, {
    name: 'Form',
    path: '/form',
  }, {
    name: 'Form Builder',
    path: '/form-builder',
    active: true
  }]

  surveyId: string | null;
  /**
   * Array for containing dropped components in a form
   */
  addedComponents!: Array<ElementInterface>;

  /**
   * Object for containing drag & drop form
   */
  subscriptionForm: FormInterface = {
    content_dnd: INITIAL_FORM,
  };

  /**
   * Property for containing which tab is activated
   * 1: Current Element
   * 2: Form Design
   */
  public activeTab = 2;

  /**
   * Array for containing only section components
   */
  public sectionComponents: Array<ElementInterface> = [];

  /**
   * Array for containing components except section component
   */
  public components: Array<ElementInterface> = [];

  /**
   * Property for containing class name when dragging element
   */
  public dragStartClass: string = '';

  /**
   * Object for containing current selected component
   */
  public selectedComponent!: null | ElementInterface;

  /**
   * Object for containing component setting properties
   */
  protected componentSettings: ComponentSettingInterface = {
    background_color: '',
    rounded_corners: 0,
    padding_top: 10,
    padding_right: 0,
    padding_bottom: 10,
    padding_left: 0,
    height: 0,
  };

  /**
   * Current language ISO code
   */
  public currentLanguage: string = '';

  constructor(
    public vcRef: ViewContainerRef,
    private modalService: NgbModal,
    private translate: TranslateService,
    private formBuilderService: FormBuilderService,
    private i18nService: I18nService,
    private formService: FormService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  /**
   * On Init handler
   */
  ngOnInit() {
    this.surveyId = this.route.snapshot.queryParamMap.get('surveyId');
    document.body.classList.add('drag-drop-page');

    this.currentLanguage = this.i18nService.language;

    this.sectionComponents = [
      {
        name: this.translate.instant('2 columns'),
        machineName: 'section',
        image: 'assets/col2.png',
        column: '2',
        addedComponents: new Array(2).fill([] as ElementInterface[]),
        deletable: true,
      },
      {
        name: this.translate.instant('3 columns'),
        machineName: 'section',
        image: 'assets/col3.png',
        column: '3',
        addedComponents: new Array(3).fill([] as ElementInterface[]),
        deletable: true,
      },
      {
        name: this.translate.instant('4 columns'),
        machineName: 'section',
        image: 'assets/col4.png',
        column: '4',
        addedComponents: new Array(4).fill([] as ElementInterface[]),
        deletable: true,
      },
      // {
      //   name: this.translate.instant('5 columns'),
      //   machineName: 'section',
      //   image: 'assets/col5.png',
      //   column: '5',
      //   addedComponents: new Array(5).fill([] as ElementInterface[]),
      //   deletable: true,
      // },
      {
        name: this.translate.instant('2 Columns (2:1)'),
        machineName: 'section',
        image: 'assets/col2-1-3.png',
        column: '2-1-3',
        addedComponents: new Array(2).fill(<ElementInterface[]>[]),
        deletable: true,
      },
      {
        name: this.translate.instant('2 Column (1:2)'),
        machineName: 'section',
        image: 'assets/col2-3-1.png',
        column: '2-3-1',
        addedComponents: new Array(2).fill([] as ElementInterface[]),
        deletable: true,
      },
    ];

    this.components = [
      TABLE,
      BUTTON,
      INPUT,
      TEXTAREA,
      DROPDOWN,
      RADIO_BUTTON,
      CHECKBOX,
      TOGGLE,
      TEXT,
      PICTURE,
      SPACER,
      SEPERATOR,
      SOCIAL,
      UPLOADER
    ];
    // this.getFormInfo()
    if (this.formConfig != null) {
      this.subscriptionForm.content_dnd = this.formConfig
      // this.formState = this.formBuilderService.formStateGenerator(this.formConfig);
    }
  }

  ngOnChanges(changes: any) {
    if (this.formConfig != null) {
      this.subscriptionForm.content_dnd = this.formConfig
      // this.formState = this.formBuilderService.formStateGenerator(this.formConfig);
    }
  }

  /**
   * On destroy handler
   */
  ngOnDestroy() {
    document.body.classList.remove('drag-drop-page');
  }

  setViewMode(mode: string) {
    switch (mode) {
      case 'mobile':
        this.formViewClass = 'mobile-mode';
        break;

      case 'tablet':
        this.formViewClass = 'tablet-mode';
        break;

      default:
        this.formViewClass = 'desktop-mode';
        break;
    }
  }

  onChangeEmitter(e: any, formRow?: number) {
    e.formRow = formRow;
    this.onChangeHandler.emit(e);
  }

  condition(element: SectionInterface) {
    return !element?.conditional || this.formState[element.ref_field_name!]?.toString() == element.ref_field_value;
  }
}
